import * as React from "react";
import * as ReactDOM from "react-dom";
import AppLocal from "./AppLocal";

ReactDOM.render(<AppLocal />, document.getElementById("root"));
